import { component, prop, emit } from '../../../decorators';

import Crud, { METADATA } from '../../../api/crud';
import { METADATA_TYPES } from '../../../config';

import KeyDetectDialog from './key-detect-dialog/key-detect-dialog.vue';
import KeyBoundItem from './key-bound-item/key-bound-item.vue';

import ComponentCreator from '../../../helpers/component.creator';

import { SYSTEM_BOUNDED_KEYS } from '../../system-hotkeys';

import union from 'lodash/union';
import map from 'lodash/map';
import reject from 'lodash/reject';
import groupBy from 'lodash/groupBy';
import transform from 'lodash/transform';
import has from 'lodash/has';

import l10n from '../../../transformers/l10n';

const metadataAPI = new Crud(METADATA);

@component({
   components: { KeyBoundItem }
})
export default class KeyLegend {
   @prop({ type: Array, required: true }) boundedKeys
   @prop({ type: Boolean, default: true }) canUseUserKeys

   /** @type {Function} */
   @emit('refresh') refreshKeys

   get systemKeys() {
      return SYSTEM_BOUNDED_KEYS;
   }

   get groupedBoundedKeys() {
      const map = groupBy(this.boundedKeys, ({ item }) => item.type);
      return transform(METADATA_TYPES, (memo, { type, tk }) => {
         if (has(map, type)) {
            const name = l10n(tk);
            memo.push({ type, name, items: map[type] });
         }
      }, []);
   }

   async add() {
      const systems = map(SYSTEM_BOUNDED_KEYS, d => d.code);
      const boundedCodes = union(systems, map(this.boundedKeys, 'code'));
      const options = { metadataLoader: this._loadTimeDataThesaurus, boundedCodes };
      try {
         const { code, item } = await ComponentCreator.dialog(KeyDetectDialog, options);
         this.refreshKeys([...this.boundedKeys, { code, item }]);
      } catch (e) {
         // noop
      }
   }

   remove({ code }) {
      const keys = reject(this.boundedKeys, { code });
      this.refreshKeys(keys);
   }

   onKeypress(code) {
      code = +code;
      try {
         const char = String.fromCharCode(code);
         const opts = { bubbles: true, cancelable: true, key: char, char, keyCode: code };
         const e = new KeyboardEvent('keyup', opts);
         e._keyCode = code;
         this.$el.dispatchEvent(e);
      } catch(e) {
         simulateKeyEvent(code);
      }
   }

   async _loadTimeDataThesaurus(type, q) {
      if (type !== 'character' && !q) {
         return [];
      }
      const options = { q, type };
      return metadataAPI.load(options);
   }
}

function simulateKeyEvent(k) {
   var oEvent = document.createEvent('KeyboardEvent');

   if (oEvent.initKeyboardEvent) {
      oEvent.initKeyboardEvent('keyup', true, true, document.defaultView, false, false, false, false, k, k);
   } else {
      oEvent.initKeyEvent('keyup', true, true, document.defaultView, false, false, false, false, k, 0);
   }
   oEvent.keyCodeVal = k;
   oEvent._keyCode = k;
   document.dispatchEvent(oEvent);
}
